import { useState, useEffect } from "react";
import useHttpHook from "../../../../Hooks/HttpHook";
import { EventLanguage } from "../../../../utils/Languages";
import MainComponentWrapper from "../../../Common/MainComponentWrapper";
import {
  ApplyPromocode,
  GetUser,
  RemovePromocode,
  RETRIEVEPROMOCODESBYEVENTS,
  ValidateCartDetails,
} from "../../../../utils/ApiConstant";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import GalleryModal from "../../../Common/Modal/GalleryModal";
import { getEventImageUrl, trimString } from "../../../../utils/Helper";
import { EventPromocodesModal } from "../../../Promocode/EventPromocodesModal";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { updCartData } from "../../../../ReduxSlice/Checkout/cartSlice";
import { EmiModal } from "./EmiModal";
import { showErrorToast } from "../../../../utils/notify";
const OrderSummamry = (props) => {
  const location = useLocation(),
    params = useParams(),
    eventId = params.eventId;
  const title = props.title ? props.title : props.cart.title;
  const installment = props?.installment;
  const queryParams = new URLSearchParams(location.search);
  const referralIdFromQuery = queryParams.get("referralId");

  const mainimage = props?.mainimage ? props?.mainimage : props.cart?.mainimage;
  const [loading, sendRequest, error] = useHttpHook();
  const [promocode, setPromocode] = useState(null);
  const [discount, setDiscount] = useState(0);
  const [subtotal, setSubtotal] = useState();
  const [total, setTotal] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [validationMessage, setValidationMessage] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [promocodes, setPromocodes] = useState([]);
  const [isPromocodeShow, setIsPromocodeShow] = useState(null);
  const [promocodePage, setPromocodePage] = useState("");
  const [showEmiOptionModal, setEmiOptionModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [serviceFee, setServiceFee] = useState(0);
  const [isShow, setIsShow] = useState(true);
  const [referralName, setReferralName] = useState(null);

  // console.log({ propsLoading: props.isLoading, loading });

  const referralId = localStorage.getItem("referralId");
  const validateCart = async () => {
    let validateResult = await sendRequest(
      ValidateCartDetails + props.eventId,
      {
        method: "get",
      }
    );
    if (
      validateResult.status === 1 &&
      location.pathname === `/attendee-information/${eventId}`
    ) {
      navigate(props.navigateLink, { replace: true });
    }
  };

  const proceedToCheckout = () => {
    if (isCheckoutPage && typeof props.onProceed === "function") {
      props.onProceed();
      return;
    }

    if (location.pathname === `/attendee-information/${eventId}`) {
      //   console.log(props.cart,'----------- cart --------------')
      let qty = 0;
      props.cart.tickets?.map((item) => {
        qty = qty + +item.quantity;
      });

      let length = 0;
      props.cart.tickets?.map((item) => {
        length = length + +item.attendees.length;
      });

      if (length < qty) {
        setValidationMessage(
          "Please fill all the attendee details to go to next step"
        );
        return;
      }
    }

    props.attendeesLeft && props.attendeesLeft > 0
      ? setValidationMessage(
          "Please fill all the attendee details to go to next step"
        )
      : location.pathname === `/attendee-information/${eventId}`
      ? validateCart()
      : location.pathname !== `/checkout/${eventId}`
      ? navigate(props.navigateLink, { replace: true })
      : setValidationMessage(null);
  };

  useEffect(() => {
    if (props.cart && props.cart.promocode) {
      setIsShow(false);
      setPromocode(props.cart.promocode);
      setDiscount(props.cart.discount);
    } else {
      setPromocode(null);
      setDiscount(0);
    }
    if (props.cart) {
      setSubtotal(props.cart.subtotal);
      setTotal(props.cart.total);
    }
    if (props.attendeesLeft && props.attendeesLeft === 0) {
      setValidationMessage(false);
    }
    if (props.cart?.tickets?.length > 0) {
      let fee = 0;
      props.cart.tickets.forEach((ticket) => {
        fee = fee + ticket.serviceFee;
      });
      setServiceFee(fee);
    }
  }, [props]);

  const handleChange = (event) => {
    setPromocode(event.target.value);
  };

  const applyPromocode = async () => {
    setErrorMessage(false);
    const code = typeof promocode === "string" ? promocode.trim() : "";

    if (!code) {
      setErrorMessage("Please enter a promocode");
      return;
    }

    if (props.cart.promocode === code) {
      setErrorMessage("Promocode already applied");
      return;
    }
    const data = { eventId: props.eventId, promocode: code, referralId };
    let cartData = await sendRequest(ApplyPromocode, { method: "post", data });
    if (cartData.status === 1) {
      setIsShow(false);
      setIsPromocodeShow(null);
      setDiscount(cartData.data.discount);
      setTotal(cartData.data.total);
      setPromocode(code);
      props.getCartData?.();
      props.getEmiInstallments?.();
    } else {
      setErrorMessage(cartData.message);
    }
  };

  const getReferralName = async (referralId) => {
    let response = await sendRequest(`${GetUser}/${referralId}`, {
      method: "get",
    });
    if (response.status === 1) {
      setReferralName(`${response.data.firstName} ${response.data.lastName}`);
    }
  };
  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  const retrievePromocodesByEvents = async () => {
    let { data } = await sendRequest(
      `${RETRIEVEPROMOCODESBYEVENTS}/${eventId}`,
      {
        method: "get",
      }
    );
    setPromocodes(data);
  };

  useEffect(() => {
    setPromocodePage(location.pathname === `/checkout/${eventId}`);
  }, [props]);
  useEffect(() => {
    retrievePromocodesByEvents();
  }, []);

  const removePromocode = async () => {
    const data = { eventId: props.eventId, referralId };
    let cartData = await sendRequest(RemovePromocode, { method: "post", data });
    if (cartData.status === 1) {
      setIsShow(true);
      setDiscount(0);
      dispatch(updCartData(cartData));
      setPromocode(null);
      setTotal(cartData.data.total);
      setErrorMessage(false);
      props.getEmiInstallments?.();
    }
  };

  useEffect(() => {
    if (referralIdFromQuery) getReferralName(referralIdFromQuery);
  }, [referralIdFromQuery]);

  const hasTickets = props.cart && props.cart.tickets?.length > 0;
  const isCheckoutPage = location.pathname === `/checkout/${eventId}`;

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <aside className="event-tickets-summary" aria-label="Order summary">
        <div className="event-tickets-summary-card">
          <h2 className="event-tickets-summary-title">
            {EventLanguage.UserEvents.ticket.Summary}
          </h2>

          <button
            type="button"
            className="event-tickets-summary-poster-wrap"
            onClick={() => setIsOpen(true)}
            aria-label="View event poster"
          >
            <img
              className="event-tickets-summary-poster"
              src={getEventImageUrl(
                mainimage && mainimage?.length > 0 ? mainimage[0]?.path : ""
              )}
              alt={title || "Event"}
            />
          </button>
          {mainimage && mainimage?.length > 0 && (
            <GalleryModal
              filesData={mainimage && mainimage.length > 0 ? [mainimage] : []}
              Open={isOpen}
              Index="0"
              onClose={() => setIsOpen(false)}
            />
          )}

          <div className="event-tickets-summary-lines">
            {!hasTickets ? (
              <p className="event-tickets-summary-empty">
                No tickets selected yet.
              </p>
            ) : (
              props.cart.tickets.map((ticket, index) => (
                <div className="event-tickets-summary-line" key={index}>
                  <div className="event-tickets-summary-line-copy">
                    <span className="event-tickets-summary-line-name">
                      {trimString(ticket.name, 24)}
                    </span>
                    <span className="event-tickets-summary-line-meta">
                      Qty: {parseFloat(ticket.quantity).toFixed(0)}
                    </span>
                  </div>
                  <strong>
                    USD{" "}
                    {parseFloat(ticket.quantity * ticket.price).toFixed(2)}
                  </strong>
                </div>
              ))
            )}
          </div>

          {hasTickets && (
            <>
              {discount > 0 && (
                <div className="event-tickets-breakdown-row">
                  <span>{EventLanguage.UserEvents.ticket.Saving}</span>
                  <strong>
                    - USD{" "}
                    {props.isFree === true
                      ? "0.00"
                      : parseFloat(props.cart.discount).toFixed(2)}
                  </strong>
                </div>
              )}

              {discount > 0 && (
                <div className="event-tickets-promo-applied">
                  <span className="event-tickets-promo-code">{promocode}</span>
                  <button
                    type="button"
                    className="event-tickets-promo-remove"
                    disabled={loading}
                    onClick={removePromocode}
                    aria-label="Remove promocode"
                  >
                    <i className="las la-trash-alt"></i>
                  </button>
                </div>
              )}

              {promocodePage &&
                props.isFree !== true &&
                isShow &&
                ["card", "emi"].includes(props?.paymentType) && (
                  <button
                    type="button"
                    className="event-tickets-promo-btn"
                    disabled={loading}
                    onClick={() => {
                      setPromocode("");
                      setErrorMessage(false);
                      setIsPromocodeShow({});
                    }}
                  >
                    Apply Promocode
                  </button>
                )}

              <div className="event-tickets-breakdown">
                <div className="event-tickets-breakdown-row">
                  <span>Subtotal</span>
                  <strong>
                    USD{" "}
                    {props.isFree === true
                      ? "0.00"
                      : parseFloat(props.cart.subtotal).toFixed(2)}
                  </strong>
                </div>
                <div className="event-tickets-breakdown-row">
                  <span>Service Fee</span>
                  <strong>
                    + USD{" "}
                    {props.isFree === true
                      ? "0.00"
                      : parseFloat(props.cart.serviceFee).toFixed(2)}
                  </strong>
                </div>
                <div className="event-tickets-breakdown-row is-total">
                  <span>Total</span>
                  <strong>
                    USD{" "}
                    {props.isFree === true
                      ? "0.00"
                      : parseFloat(props.cart.total).toFixed(2)}
                  </strong>
                </div>
              </div>

              {props.isShowSplitPayment &&
                Number(props.minSplitOrderAmount || 0) <=
                  Number(props.cart?.total || 0) &&
                installment?.installments?.length > 0 && (
                  <div className="emi-option-summary mt-3">
                    <div className="emi-option-or mb-2">
                      <hr className="or-hypen" />
                      <span className="or-center">OR</span>
                      <hr className="or-hypen" />
                    </div>
                    <EmiOption
                      montlyPrice={installment?.montlyPrice}
                      interval={installment?.interval}
                      onClick={() => setEmiOptionModal(true)}
                    />
                  </div>
                )}

              {errorMessage && (
                <span className="event-tickets-error">{errorMessage}</span>
              )}

              <div className="event-tickets-referral-note">
                {referralIdFromQuery ? (
                  <>
                    This order is linked to{" "}
                    <strong>{referralName || "referral"}</strong>'s referral.
                  </>
                ) : (
                  <>This order is not linked to any referral.</>
                )}
              </div>

              {validationMessage && (
                <span className="event-tickets-error">{validationMessage}</span>
              )}

              <button
                type="button"
                className="event-details-btn event-details-btn-block"
                disabled={loading || props.isLoading}
                onClick={proceedToCheckout}
              >
                <i className="bi bi-bag-check" aria-hidden="true"></i>
                <span>{EventLanguage.UserEvents.ticket.Proceed}</span>
              </button>
            </>
          )}
        </div>
      </aside>

      <EventPromocodesModal
        promocode={promocode || ""}
        setPromocode={setPromocode}
        promocodes={promocodes}
        show={!!isPromocodeShow}
        apply={applyPromocode}
        onHide={() => {
          setIsPromocodeShow(null);
          if (!props.cart?.promocode) {
            setPromocode("");
          }
        }}
      />
      <EmiModal
        show={showEmiOptionModal}
        totalCost={parseFloat(props.cart?.total).toFixed(2)}
        emis={installment?.installments}
        interval={installment?.interval}
        onClose={() => {
          setEmiOptionModal(false);
        }}
      />
    </MainComponentWrapper>
  );
};

function EmiOption({ montlyPrice, interval, onClick }) {
  const periodLabel = interval === "month" ? "month" : "day";
  return (
    <div className="emi-option-summary-text">
      <div className="price">USD {montlyPrice}/{periodLabel}</div>
      <div onClick={onClick} className="option-text">
        Split Payment Option
      </div>
    </div>
  );
}
export default OrderSummamry;
